export default {"src":"/_next/static/media/facebook-icon.636d4361.svg","height":49,"width":40,"blurWidth":0,"blurHeight":0};